/**
 * Configuração lida de variáveis Vite (`import.meta.env.VITE_*`) — injetadas
 * em build time pelo Cloudflare Pages. Validamos na fronteira (boot do app):
 * se faltar algo essencial, falhamos cedo com mensagem clara em vez de quebrar
 * silenciosamente num fetch lá na frente.
 */

const DEFAULT_API_URL = "https://api.iakyra.app";

function readApiUrl(): string {
  // Em dev usamos caminho relativo ("") + proxy do Vite (ver server.proxy no
  // vite.config) pra evitar CORS local — o Worker só libera rotina.bio/iakyra.*
  // em produção, não a porta do dev server. Em build (prod) lê VITE_KYRA_API_URL.
  if (import.meta.env.DEV) return "";
  const raw = import.meta.env.VITE_KYRA_API_URL?.trim();
  return (raw && raw.replace(/\/+$/, "")) || DEFAULT_API_URL;
}

function readRequired(name: string, value: string | undefined): string {
  const v = value?.trim();
  if (!v) {
    throw new Error(
      `[env] Variável ${name} ausente. Defina-a no .env (dev) ou nas env vars do Cloudflare Pages (prod).`,
    );
  }
  return v;
}

export const env = {
  apiUrl: readApiUrl(),
  supabaseUrl: readRequired("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: readRequired(
    "VITE_SUPABASE_ANON_KEY",
    import.meta.env.VITE_SUPABASE_ANON_KEY,
  ),
} as const;
